import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import EnrollmentQuotationCreatePage from './enrollment-quotation-create'
import EnrollmentQuotationListPage from './enrollment-quotation-list'
import EnrollmentQuotationUpdatePage from './enrollment-quotation-update'

const enrollmentQuotationRoutes: Route[] = [
  {
    path: Paths.ENROLLMENT_QUOTATION_LIST_PAGE,
    element: <EnrollmentQuotationListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.ENROLLMENT_QUOTATION_CREATE_PAGE,
    element: <EnrollmentQuotationCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.ENROLLMENT_QUOTATION_UPDATE_PAGE,
    element: <EnrollmentQuotationUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default enrollmentQuotationRoutes
